'use client'

import { useTranslation } from '@/lib/i18n/useTranslation.client'
import { Picture } from '@/ui/media/picture/Picture.client'
import { Media } from '@gql-generated/graphql'
import { ErrorPageHero } from '../../components/error-page-hero/ErrorPageHero.client'

/**
 * @design https://www.figma.com/design/taZo3cSvulzI4N9o8xLrxB/08.CGV-CGU-404-500-Contact?node-id=1-13814
 */
export function NotFoundErrorPage({ header }: { header?: React.ReactElement }) {
  const { t } = useTranslation(['NotFoundErrorPage'])

  return (
    <ErrorPageHero
      skin="body"
      title={t('NotFoundErrorPage:title')}
      paragraphs={[t('NotFoundErrorPage:description.line1')]}
      image={
        <Picture
          image={{ set: [{ media: Media.Mobile, url: '/media/image/error-404.svg' }], alt: '' }}
          isDecorative
          width="280"
          height="280"
        />
      }
      headerOutlet={header}
    />
  )
}
